import { createAsyncThunk } from "@reduxjs/toolkit";
import legacyServices from "./../../Services/legacyServices";
import { ResponseMessageHandler } from "../../globals/components/notification";
import { message } from "antd";
import { getBatchwiseContracts } from "../LegalAssociateTask/LegalAssociateTask.Action";
import { getCreditsDetailByCompanyId } from "../Company/company.action";
export const getLegacyImportList = createAsyncThunk(
  "legacyImports/fetchLegacyImportsData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      let res = await legacyServices.getLegacyImportListAPI({
        ...data,
        limit: data?.pageSize || 20,
        page: data?.current || 1,
      });

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const getContractsByInstanceId = createAsyncThunk(
  "legacyImports/getContractsByInstanceId",
  async (data, { rejectWithValue }) => {
    try {
      let res = await legacyServices.getContractsByInstanceIdAPI({
        ...data,
        limit: data?.pageSize || 10,
        page: data?.current || 1,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const getDistributedContractDetails = createAsyncThunk(
  "legacyImports/getDistributedContractDetails",
  async (data, { rejectWithValue }) => {
    try {
      let res = await legacyServices.getDistributedContractDetailsAPI({
        ...data,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const getBufferDataFromUrl = createAsyncThunk(
  "legacyImports/getBufferDataFromUrl",
  async (data, { rejectWithValue }) => {
    try {
      let res = await legacyServices.getBufferDataFromUrlAPI({
        ...data,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const extractMetaDataWithAI = createAsyncThunk(
  "legacyImports/extractMetaDataWithAI",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      let res = await legacyServices.extractMetaDataWithAIAPI({
        ...data,
      });
      dispatch(getCreditsDetailByCompanyId({}));

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const editHistoricalContracts = createAsyncThunk(
  "legacyImports/editHistoricalContracts",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const {
        form_data,
        historicalTaskPagination,
        contractsByInstanceIdPagination = {},
        groupData,
        type,
        batchwiseTaskPagination,
        FillAndUpdateContractsDrawerRecord,
        LegacyImportListPagination,
      } = data;

      let res = await legacyServices.editHistoricalContractsAPI(form_data);
      if (type === "editforLegal") {
        dispatch(
          getBatchwiseContracts({
            ...batchwiseTaskPagination,
            legalAssociateId:
              FillAndUpdateContractsDrawerRecord?.legalAssociateId,

            assignedBatchId:
              FillAndUpdateContractsDrawerRecord?.assignedBatchId,
          })
        );
      } else {
        dispatch(
          getContractsByInstanceId({
            instanceId: groupData?._id,
            ...contractsByInstanceIdPagination,
          })
        );
      }
      dispatch(getLegacyImportList(LegacyImportListPagination));

      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const createBulkLegacyContract = createAsyncThunk(
  "legacyImports/createBulkLegacyContract",
  async (
    { data, LegacyImportListPagination },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let res = await legacyServices.createBulkLegacyContractAPI(data);
      dispatch(getLegacyImportList(LegacyImportListPagination));

      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const getTokenforGoogledrive = createAsyncThunk(
  "legacyImports/getTokenforGoogledrive",
  async (data, { rejectWithValue }) => {
    try {
      let res = await legacyServices.getTokenforGoogledriveAPI(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const Sendfilesandfolder = createAsyncThunk(
  "legacyImports/Sendfilesandfolder",
  async (data, { rejectWithValue }) => {
    try {
      let res = await legacyServices.SendfilesandfolderAPI(data);
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const getDuplicatesContractLists = createAsyncThunk(
  "legacyImports/getDuplicatesContractLists",
  async (data, { rejectWithValue }) => {
    try {
      let res = await legacyServices.getDuplicatesContractListsAPI(data);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return rejectWithValue(message);
    }
  }
);
export const deleteDuplicatesContracts = createAsyncThunk(
  "legacyImports/deleteDuplicatesContracts",
  async ({ data, pagination }, thunkAPI) => {
    try {
      const res = await legacyServices.deleteDuplicatesContractsAPI(data);
      thunkAPI.dispatch(getContractsByInstanceId(pagination));
      thunkAPI.dispatch(
        getDistributedContractDetails({
          instanceId: `${pagination?.instanceId}`,
        })
      );
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getLegalAssociates = createAsyncThunk(
  "legacyImports/getLegalAssociates",
  async (data, thunkAPI) => {
    try {
      const res = await legacyServices.getLegalAssociatesAPI({
        ...data,
        limit: data.pageSize,
        page: data.current,
      });

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteInstance = createAsyncThunk(
  "legacyImports/deleteInstance",
  async (data, thunkAPI) => {
    try {
      const res = await legacyServices.deleteInstanceAPI(data);
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getBulkAssignedData = createAsyncThunk(
  "legacyImports/getBulkAssignedData",
  async (data, thunkAPI) => {
    try {
      const res = await legacyServices.getBulkAssignedDataAPI(data);
      // thunkAPI.dispatch(getDetails({ taskId: data.taskId }));
      // ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getBulkAssignTasktoLegalAssociates = createAsyncThunk(
  "legacyImports/getBulkAssignTasktoLegalAssociates",
  async ({ data, instanceId = "" }, thunkAPI) => {
    try {
      let res = await legacyServices.getBulkAssignTasktoLegalAssociatesAPI({
        ...data,
      });
      thunkAPI.dispatch(
        getContractsByInstanceId({
          sortBy: "DESC",
          instanceId: instanceId,
        })
      );

      thunkAPI.dispatch(
        getDistributedContractDetails({
          instanceId: instanceId,
        })
      );
      thunkAPI.dispatch(
        getBulkAssignedData({
          instanceId: instanceId,
        })
      );
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getBulkReAssignTasktoLegalAssociates = createAsyncThunk(
  "legacyServices/getBulkReAssignTasktoLegalAssociates",
  async ({ data, instanceId = "" }, thunkAPI) => {
    try {
      let res = await legacyServices.getBulkReAssignTasktoLegalAssociatesAPI({
        ...data,
      });
      thunkAPI.dispatch(
        getContractsByInstanceId({
          sortBy: "DESC",
          instanceId: instanceId,
        })
      );
      thunkAPI.dispatch(
        getDistributedContractDetails({
          instanceId: instanceId,
        })
      );

      thunkAPI.dispatch(
        getBulkAssignedData({
          instanceId: instanceId,
        })
      );
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAssignTasktoLegalAssociates = createAsyncThunk(
  "legacyServices/getAssignTasktoLegalAssociates",
  async (
    { data, instanceId = "", contractsByInstanceIdPagination },
    thunkAPI
  ) => {
    try {
      let res = await legacyServices.getAssignTasktoLegalAssociatesAPI({
        ...data,
      });
      thunkAPI.dispatch(
        getContractsByInstanceId({
          sortBy: "DESC",
          instanceId: instanceId,
          ...contractsByInstanceIdPagination,
        })
      );
      thunkAPI.dispatch(
        getDistributedContractDetails({
          instanceId: instanceId,
        })
      );
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const unassignandReassignContractToLegalAssociate = createAsyncThunk(
  "legacyServices/unassignandReassignContractToLegalAssociate",
  async (
    { data, contractsByInstanceIdPagination, isCustomMessage },
    thunkAPI
  ) => {
    try {
      const res = await legacyServices.unassignContractToLegalAssociateAPI({
        ...data,
      });
      thunkAPI.dispatch(
        getDistributedContractDetails({
          instanceId: data?.instanceId || "",
        })
      );
      thunkAPI.dispatch(
        getContractsByInstanceId(contractsByInstanceIdPagination)
      );
      if (isCustomMessage) {
        message.success("Contract unassigned successfully");
      } else {
        ResponseMessageHandler(res);
      }
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getExcelforBulkHistorical = createAsyncThunk(
  "legacyServices/getExcelforBulkHistorical",
  async (data, thunkAPI) => {
    try {
      const res = await legacyServices.getExcelforBulkHistoricalAPI(data);
      const url = URL.createObjectURL(new Blob([res]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "importrecord.xlsx");

      link.click();
      // ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateMetaDataThrouCSV = createAsyncThunk(
  "legacyImports/updateMetaDataThrouCSV",
  async (data, thunkAPI) => {
    try {
      const res = await legacyServices.updateMetaDataThrouCSVAPI(data);
      thunkAPI.dispatch(
        getDistributedContractDetails({
          instanceId: data.instanceId,
        })
      );
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getImportsDetailsById = createAsyncThunk(
  "legacyImports/getImportsDetailsById",
  async (data, thunkAPI) => {
    try {
      const res = await legacyServices.getImportDetailsAPI(data);

      // ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const FindMissingContract = createAsyncThunk(
  "legacyImports/findmissingcontract",
  async (data, thunkAPI) => {
    try {
      const res = await legacyServices.findmissingcontractAPI(data);
      // thunkAPI.dispatch(getDetails({ taskId: data.taskId }));
      thunkAPI.dispatch(getCreditsDetailByCompanyId({}));

      thunkAPI.dispatch(getImportsDetailsById(data));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
